module.exports = __webpack_public_path__ + "img/yj.2169fdd8.png";